import { render, staticRenderFns } from "./DList.vue?vue&type=template&id=4a477f4d"
import script from "./DList.vue?vue&type=script&lang=js"
export * from "./DList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports